<template>
	<section class="container">
		<div class="card-area">
			<div class="svg-child"></div>
			<div class="content-child">
				<p class="first-title text-left text-primary">- Explore -</p>
				<h2 class="text-left">A development lab for you</h2>
				<p class="text-left">
					as a beginner , you'll be able to find a learning resource for you to accelerate and learn stuff!
				</p>
			</div>
		</div>
	</section>
</template>

<script>
	
	export default {

	  name: 'SecondShowCase',

	  data () {
	    return {

	    }
	  }
	}
</script>

<style lang="css" scoped>
	.first-title {
		margin: 0;
		padding: 0;
		font-family: "Poppins";
		font-size: 17px;
	}

	.card-area {
		display: grid;
		grid-template-columns: 3fr 2fr;
		grid-gap: 30px;
		margin-top: var(--margin-between-sections-in-homepage--);
		margin-bottom: var(--margin-between-sections-in-homepage--);
	}
	.card-area {
		font-family: var(--font--);
	}
	.svg-child {
		background-image: url('../.././assets/undraw_online_test_gba7.svg');
		background-position: center;
		background-size: contain;
		height: 350px;
		background-repeat: no-repeat;

	}
	.content-child {
		padding-top: 80px;
	}
	@media only screen and (max-width: 800px) {
		.card-area {
			display: grid;
			grid-template-columns: 2fr;
			grid-gap:10px;
		}		
	}
</style>